import axios from 'axios';

// Urls
const UAT_URL = `https://www.ackodev.com`;

// Axios client
const axiosClient = axios.create();

// Axios Configs
axiosClient.defaults.baseURL = UAT_URL;
axiosClient.defaults.headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
// axiosClient.defaults.timeout = 4000;
axiosClient.defaults.withCredentials = true;

// Request methods
export const getRequest = async (URL: string) => {
  const response = await axiosClient.get(`${URL}`);
  return response;
};

export async function postRequest(URL: string, payload: any = {}) {
  const response = await axiosClient.post(`${URL}`, payload);
  return response;
}

export async function putRequest(URL: string, payload: any = {}, token = '') {
  const headers = !!token
    ? {
        headers: {
          'x-captcha-token': token,
        },
      }
    : {};
  const response = await axiosClient.put(`${URL}`, payload, headers);
  return response;
}
